import { Table as NovaTable, TableProps as NovaTableProps } from '@fme-nova/components'
import { default as MuiTable, TableProps as MuiTableProps } from '@mui/material/Table'

import { createComponentWrapperWithRef } from '../../theme'

export const Table = createComponentWrapperWithRef<MuiTableProps | NovaTableProps>(
  {
    mui: MuiTable,
    nova: NovaTable,
  },
  'Table',
)
